import React from 'react';
import './Hero.css';

import logo from '../img/logo.png';

function Hero() {
  return (
    <div className="hero">
      <h1>Welcome to Sounds Of Serenity</h1>
      <p>Choose a soundscape below...</p>
      <img src={logo} alt="" />
    </div>
  );
}

export default Hero;
